import { Link } from "react-router-dom";
import useSWR from "swr";
import { ArrowUpRight } from "lucide-react";
import { fetcher, swrOpts } from "@/lib/api";

export const CategoryTiles = ({ exclude }) => {
  const { data } = useSWR("/categories", fetcher, swrOpts);
  const cats = (data?.items || []).filter((c) => c.primary && c.product_count && c.slug !== exclude);
  if (!data) return <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">{Array.from({ length: 8 }).map((_, i) => <div key={i} className="aspect-[4/3] animate-pulse rounded-2xl bg-panel" />)}</div>;
  return (
    <ul className="grid grid-cols-2 gap-3 sm:grid-cols-3 sm:gap-5 lg:grid-cols-4" data-testid="category-tiles">
      {cats.map((c) => {
        const to = c.slug === "deals" ? "/deals/" : c.url;
        return (
          <li key={c.id}>
            <Link to={to} className="group flex h-full flex-col overflow-hidden rounded-2xl border border-line bg-panel transition-[border-color] hover:border-gold/60" data-testid={`category-tile-${c.slug}`}>
              <span className="block aspect-[4/3] overflow-hidden bg-white">
                {c.image && <img src={c.image} alt="" width="320" height="240" loading="lazy" className="h-full w-full object-contain p-3 transition-transform duration-500 group-hover:scale-105" />}
              </span>
              <span className="flex items-end justify-between gap-2 p-4 sm:p-5">
                <span>
                  <span className="block font-display text-xl font-semibold text-white sm:text-2xl">{c.name}</span>
                  <span className="text-xs text-gray-400">{c.product_count} products</span>
                </span>
                <ArrowUpRight className="h-5 w-5 text-gold transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" aria-hidden />
              </span>
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export const LocationChips = ({ exclude }) => {
  const { data } = useSWR("/locations", fetcher, swrOpts);
  return (
    <ul className="flex flex-wrap gap-2" data-testid="location-chips">
      {(data?.items || []).filter((l) => l.slug !== exclude).map((l) => (
        <li key={l.slug}><Link to={`/locations/${l.slug}/`} className="chip" data-testid={`location-chip-${l.slug}`}>{l.hub ? "All of DC" : l.name}</Link></li>
      ))}
    </ul>
  );
};
